import {
  centerCrop,
  makeAspectCrop,
  PixelCrop,
} from "react-image-crop";
import {
  ALLOWED_PROFILE_IMAGE_TYPES,
  MAX_PROFILE_IMAGE_SIZE,
  PROFILE_IMAGE_EXPORT_SIZE,
  PROFILE_IMAGE_SIZE_VALIDATION_MESSAGE,
  PROFILE_IMAGE_TYPE_VALIDATION_MESSAGE,
} from "./profileImageCrop.constants";

export const centerAspectCrop = (
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
) => {
  return centerCrop(
    makeAspectCrop({ unit: "%", width: 90 }, aspect, mediaWidth, mediaHeight),
    mediaWidth,
    mediaHeight,
  );
};

export const renderCropToCanvas = (
  image: HTMLImageElement,
  canvas: HTMLCanvasElement,
  crop: PixelCrop,
) => {
  const ctx = canvas.getContext("2d");

  if (!ctx) throw new Error("No 2d context");

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  const sourceX = crop.x * scaleX;
  const sourceY = crop.y * scaleY;
  const sourceWidth = crop.width * scaleX;
  const sourceHeight = crop.height * scaleY;

  canvas.width = PROFILE_IMAGE_EXPORT_SIZE;
  canvas.height = PROFILE_IMAGE_EXPORT_SIZE;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(
    image,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    0,
    0,
    canvas.width,
    canvas.height,
  );
};

export const resolveProfileImageUserId = (
  ...ids: Array<string | number | null | undefined>
) => {
  for (const id of ids) {
    const numericId = Number(id);
    if (Number.isInteger(numericId) && numericId > 0) {
      return numericId;
    }
  }

  return null;
};

export const getSelectedImageFile = async (imageUrl: string) => {
  const response = await fetch(imageUrl);
  const blob = await response.blob();
  const extension = blob.type.split("/")[1] || "jpg";
  return new File([blob], `profile.${extension}`, {
    type: blob.type || "image/jpeg",
  });
};

export const validateProfileImageFile = (file: File) => {
  if (!ALLOWED_PROFILE_IMAGE_TYPES.includes(file.type)) {
    return PROFILE_IMAGE_TYPE_VALIDATION_MESSAGE;
  }

  if (file.size >= MAX_PROFILE_IMAGE_SIZE) {
    return PROFILE_IMAGE_SIZE_VALIDATION_MESSAGE;
  }

  return "";
};

export const isObjectUrl = (
  url: string | null | undefined,
): url is string => {
  return typeof url === "string" && url.startsWith("blob:");
};
